export const weekdayHours = [[8, 0], [20, 30]]; // 8am to 8:30pm local
export const weekendHours = [[10, 0], [18, 0]]; // 10am to 6pm local
export const holidayHours = {
  '20201125': [8, 15], // day before Thanksgiving
  '20201126': [], // Thanksgiving day
  '20201225': [], // Christmas day
  '20210101': [], // New Year's day
  '20211124': [8, 15], // day before Thanksgiving
  '20211125': [], // Thanksgiving day
  '20211225': [], // Christmas day
  '20220101': [] // New Year's day
};

const startEndTime = function (momentObj, startOrEnd) { //
  const targetDate = momentObj.clone().startOf('day');
  const i = startOrEnd === 'start' ? 0 : 1;
  let targetTime;
  if (holidayHours[targetDate.format('YYYYMMDD')]) {
    const hours = holidayHours[targetDate.format('YYYYMMDD')];
    targetTime = targetDate.add(hours[i], 'hours') || null;
  } else {
    targetTime = isWeekend(targetDate)
      ? targetDate.add(weekendHours[i][0], 'hours').add(weekendHours[i][1], 'minutes')
      : targetDate.add(weekdayHours[i][0], 'hours').add(weekdayHours[i][1], 'minutes');
  }
  return targetTime;
};

export const numberOfDays = 7;

export function isWeekend(momentObj) {
  return [0, 6].indexOf(momentObj.day()) > -1;
}

export function callableHoursStartTime(momentObj) { //
  return startEndTime(momentObj, 'start');
}

export function callableHoursEndTime(momentObj) { //
  return startEndTime(momentObj, 'end');
}


export function nowCallableTime(targetDateObj) { //
  let nowish = targetDateObj.clone().add('5', 'minutes');
  if (nowish.isBefore(callableHoursStartTime(nowish)) ||
    nowish.isSameOrAfter(callableHoursEndTime(nowish))) {
    return null;
  }

  if (!businessCoreHours(nowish)) {
    return null;
  }

  return nowish;
}

// VT Business hours in EST time zone
// Weekend  12pm - 1am UTC  || 8:30am - 7pm EST
// Weekdays 12pm - 4am UTC  || 8:30am - 10pm EST
function businessCoreHours(targetDateObj) { //
  let targetDateObjEST = targetDateObj.clone().utcOffset('-05:00');
  let isWeekend = [0, 6].includes(targetDateObjEST.day());
  let [[startHr, startMin], [endHr, endMin]] = isWeekend ? [[8, 30], [19, 0]] : [[8, 30], [22, 0]];
  const start = targetDateObjEST.clone().startOf('day')
    .add(startHr, 'hours').add(startMin, 'minutes');
  const end = targetDateObjEST.clone().startOf('day')
    .add(endHr, 'hours').add(endMin, 'minutes');
  return [start, end];
}

export function isBusinessCoreHours(testTime) {
  let [start, end] = businessCoreHours(testTime);
  return testTime.isSameOrAfter(start) && testTime.isBefore(end);
}
